import { Col, Divider, Row, Space } from "antd";
import { Form, Formik } from "formik";

import { Button } from "components/elements";
import SubInfoSwitch from "components/elements/InfoSwitch/SubInfoSwitch";
import ColumnSwitch from "components/elements/InfoSwitch/columnSwitch";
import { Input, Select } from "components/form";
import { MainLayout } from "components/layouts";

import styles from "../styles/Attendance.module.css";

const AttendanceCreate = ({
  initialValues = {},
  onBack = () => { },
  onSubmitCreate = () => { },
  goToCancle = () => { },
  setMenu = () => { },
}) => {
  return (
    <MainLayout
      title="Create Leave Type"
      breadcrumb={[
        { title: "Home", link: "/" },
        { title: "Configuration", link: "/" },
        { title: "Attendance Setting", link: "/" },
        { title: "Create" },
      ]}
    >
      <Formik initialValues={initialValues} onSubmit={onSubmitCreate}>
        {({ values = {}, setTouched = () => { } }) => {
          return (
            <Form>
              <Space
                className={styles.subContainer}
                size={24}
                direction="vertical"
              >
                <div className="card">
                  <Row justify="space-between">
                    <b className={styles.infoTopic}>Create</b>
                  </Row>
                  <Divider />
                  <Row gutter={[24, 16]}>
                    <Col span={12}>
                      <Input
                        name="name_th"
                        label="Leave Type Name (TH) *"
                        placeholder="Leave Type Name (TH) *"
                        size="large"
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="name_en"
                        label="Leave Type Name (EN) *"
                        placeholder="Leave Type Name (EN) *"
                        size="large"
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="category"
                        label="Leave Category *"
                        placeholder="Leave Category *"
                        size="large"
                        options={[
                          { label: "Offsite Work", value: "offsiteWork" },
                          { label: "Leave", value: "leave" },
                        ]}
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="description"
                        label="Description *"
                        placeholder="Description *"
                        size="large"
                      />
                    </Col>
                  </Row>

                  <Row justify="space-between" style={{ paddingTop: "24px" }}>
                    <b className={styles.infoTopic}>Leave Request</b>
                  </Row>
                  <Divider />
                  {values.category === null && (
                    <Row gutter={[24, 16]}>
                      <Col span={12}>
                        <Select
                          name="minimum_leave"
                          label="Minimum leave required *"
                          placeholder="Minimum leave required *"
                          size="large"
                          options={[
                            { label: "60 Minutes", value: "60" },
                            { label: "55 Minutes", value: "55" },
                            { label: "50 Minutes", value: "50" },
                            { label: "45 Minutes", value: "45" },
                          ]}
                        />
                      </Col>
                      <Col span={12}>
                        <Select
                          name="document_limit"
                          label="Document limit per day *"
                          placeholder="Document limit per day *"
                          size="large"
                          options={[
                            { label: "1 document", value: "1" },
                            { label: "2 document", value: "2" },
                            { label: "3 document", value: "3" },
                            { label: "4 document", value: "4" },
                          ]}
                        />
                      </Col>
                      <Col span={12}>
                        <Select
                          name="request_condition"
                          label="Request Condition *"
                          placeholder="Request Condition *"
                          size="large"
                          options={[]}
                        />
                      </Col>
                      <Col>
                        <ColumnSwitch label="Permanent employees only" />
                      </Col>
                    </Row>
                  )}
                  {values.category === "leave" && (
                    <Row gutter={[24, 16]}>
                      <Col span={12}>
                        <Select
                          name="minimum_leave"
                          label="Minimum leave required *"
                          placeholder="Minimum leave required *"
                          size="large"
                          options={[
                            { label: "60 Minutes", value: "60" },
                            { label: "55 Minutes", value: "55" },
                            { label: "50 Minutes", value: "50" },
                            { label: "45 Minutes", value: "45" },
                          ]}
                        />
                      </Col>
                      <Col span={12}>
                        <Select
                          name="document_limit"
                          label="Document limit per day *"
                          placeholder="Document limit per day *"
                          size="large"
                          options={[
                            { label: "1 document", value: "1" },
                            { label: "2 document", value: "2" },
                            { label: "3 document", value: "3" },
                            { label: "4 document", value: "4" },
                          ]}
                        />
                      </Col>
                      <Col span={12}>
                        <Select
                          name="request_condition"
                          label="Request Condition *"
                          placeholder="Request Condition *"
                          size="large"
                          options={[
                            {
                              label: "Allow Advance and Backdate",
                              value: "advanceAndbackdate",
                            },
                            { label: "Advance Only", value: "advanceOnly" },
                            { label: "Allow Backdate", value: "allowBackdate" },
                          ]}
                        />
                      </Col>

                      {values.request_condition === null && (
                        <Col>
                          <ColumnSwitch label="Permanent employees only" />
                        </Col>
                      )}
                      {values.request_condition === "advanceAndbackdate" && (
                        <>
                          <Col span={12}></Col>

                          <Col span={12}>
                            {values.category === "leave" && (
                              <SubInfoSwitch label="Half-day Leave" />
                            )}
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Consecutive Leave Limit" />
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <Input
                              name="MaximumOfConsecutiveLeave"
                              label="Maximum of Consecutive Leave"
                              placeholder="Days"
                              size="large"
                            />
                          </Col>
                        </>
                      )}
                      {values.request_condition === "advanceOnly" && (
                        <>
                          <Col span={12}>
                            <Input
                              name="AdvanceAtLeast"
                              label="Advance at least"
                              placeholder="Advance at least"
                              size="large"
                            />
                          </Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Enable Emergency Leave" />
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <Input
                              name="annualLeaveLimit"
                              label="Annual Leave Limit"
                              placeholder="Days"
                              size="large"
                            />
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            {values.category === "leave" && (
                              <SubInfoSwitch label="Half-day Leave" />
                            )}
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Consecutive Leave Limit" />
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <Input
                              name="maximumOfConsecutiveLeave"
                              label="Maximum of Consecutive Leave"
                              placeholder="Days"
                              size="large"
                            />
                          </Col>
                        </>
                      )}
                      {values.request_condition === "allowBackdate" && (
                        <>
                          <Col span={12}>
                            <Input
                              name="backdateWithIn"
                              label="Backdate within"
                              placeholder="Days"
                              size="large"
                            />
                          </Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Enable Emergency Leave" />
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <Input
                              name="annualLeaveLimit"
                              label="Annual Leave Limit"
                              placeholder="Time"
                              size="large"
                            />
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            {values.category === "leave" && (
                              <SubInfoSwitch label="Half-day Leave" />
                            )}
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Consecutive Leave Limit" />
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <Input
                              name="maximumOfConsecutiveLeave"
                              label="Maximum of Consecutive Leave"
                              placeholder="Days"
                              size="large"
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  )}
                  {values.category === "offsiteWork" && (
                    <Row gutter={[24, 16]}>
                      <Col span={12}>
                        <Select
                          name="minimum_leave"
                          label="Minimum leave required *"
                          placeholder="Minimum leave required *"
                          size="large"
                          options={[
                            { label: "60 Minutes", value: "60" },
                            { label: "55 Minutes", value: "55" },
                            { label: "50 Minutes", value: "50" },
                            { label: "45 Minutes", value: "45" },
                          ]}
                        />
                      </Col>
                      <Col span={12}>
                        <Select
                          name="document_limit"
                          label="Document limit per day *"
                          placeholder="Document limit per day *"
                          size="large"
                          options={[
                            { label: "1 document", value: "1" },
                            { label: "2 document", value: "2" },
                            { label: "3 document", value: "3" },
                            { label: "4 document", value: "4" },
                          ]}
                        />
                      </Col>
                      <Col span={12}>
                        <Select
                          name="request_condition"
                          label="Request Condition *"
                          placeholder="Request Condition *"
                          size="large"
                          options={[
                            {
                              label: "Allow Advance and Backdate",
                              value: "advanceAndbackdate",
                            },
                            { label: "Advance Only", value: "advanceOnly" },
                            { label: "Allow Backdate", value: "allowBackdate" },
                          ]}
                        />
                      </Col>

                      {values.request_condition === null && (
                        <Col>
                          <ColumnSwitch label="Permanent employees only" />
                        </Col>
                      )}
                      {values.request_condition === "advanceAndbackdate" && (
                        <>
                          <Col span={12}></Col>

                          <Col span={12}>
                            {values.category === "leave" && (
                              <SubInfoSwitch label="Half-day Leave" />
                            )}
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Consecutive Leave Limit" />
                          </Col>
                          <Col span={12}></Col>
                          <Col span={12}>
                            <Input
                              name="MaximumOfConsecutiveLeave"
                              label="Maximum of Consecutive Leave"
                              placeholder="Days"
                              size="large"
                            />
                          </Col>
                        </>
                      )}
                      {values.request_condition === "advanceOnly" && (
                        <>
                          <Col span={12}>
                            <Input
                              name="AdvanceAtLeast"
                              label="Advance at least"
                              placeholder="Advance at least"
                              size="large"
                            />
                          </Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Enable Emergency Leave" />
                          </Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Consecutive Leave Limit" />
                          </Col>
                          <Col span={12}>
                            <Input
                              name="annualLeaveLimit"
                              label="Annual Leave Limit"
                              placeholder="Days"
                              size="large"
                            />
                          </Col>

                          <Col span={12}>
                            <Input
                              name="maximumOfConsecutiveLeave"
                              label="Maximum of Consecutive Leave"
                              placeholder="Time"
                              size="large"
                            />
                          </Col>
                        </>
                      )}
                      {values.request_condition === "allowBackdate" && (
                        <>
                          <Col span={12}>
                            <Input
                              name="AdvanceAtLeast"
                              label="Advance at least"
                              placeholder="Advance at least"
                              size="large"
                            />
                          </Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Enable Emergency Leave" />
                          </Col>
                          <Col span={12}>
                            <SubInfoSwitch label="Consecutive Leave Limit" />
                          </Col>
                          <Col span={12}>
                            <Input
                              name="annualLeaveLimit"
                              label="Annual Leave Limit"
                              placeholder="Days"
                              size="large"
                            />
                          </Col>

                          <Col span={12}>
                            <Input
                              name="maximumOfConsecutiveLeave"
                              label="Maximum of Consecutive Leave"
                              placeholder="Time"
                              size="large"
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  )}
                  {values.category === "offsiteWork" && (
                    <>
                      <Row
                        justify="space-between"
                        style={{ paddingTop: "24px" }}
                      >
                        <b className={styles.infoTopic}>Leave Condition</b>
                      </Row>
                      <Divider />
                      <Row gutter={[24, 16]}>
                        <Col span={12}>
                          <SubInfoSwitch label="Permanent employees only" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Allow Once" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Count holidays as leave days" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Diligence Allowance" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Attachment required" />
                        </Col>
                        <Col span={12}></Col>
                        <Col span={12}>
                          <Input
                            name="whenLeavingSince"
                            label="When leaving since"
                            placeholder="Days"
                            size="large"
                          />
                        </Col>
                        <Col span={12}></Col>
                        <Col span={12}>
                          <Select
                            name="gender"
                            label="Gender  *"
                            placeholder="Gender *"
                            size="large"
                            options={[
                              { label: "All Gender", value: "all_Gender" },
                              { label: "Male", value: "male" },
                              { label: "Female", value: "female" },
                            ]}
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  {values.category === "leave" && (
                    <>
                      <Row
                        justify="space-between"
                        style={{ paddingTop: "24px" }}
                      >
                        <b className={styles.infoTopic}>Leave Condition</b>
                      </Row>
                      <Divider />
                      <Row gutter={[24, 16]}>
                        <Col span={12}>
                          <SubInfoSwitch label="Permanent employees only" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Allow Once" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Count holidays as leave days" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Extra Allowance" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Diligence Allowance" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Leave Without Pay" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Include probation period" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Available only in the birth month" />
                        </Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Attachment required" />
                        </Col>
                        <Col span={12}></Col>
                        <Col span={12}>
                          <Input
                            name="whenLeavingSince"
                            label="When leaving since"
                            placeholder="Days"
                            size="large"
                          />
                        </Col>
                        <Col span={12}></Col>
                        <Col span={12}>
                          <SubInfoSwitch label="Accumulated Annual Leave" />
                        </Col>
                        <Col span={12}></Col>
                        <Col span={12}>
                          <Input
                            name="maximumLeaveAccumulation*"
                            label="Maximum Leave Accumulation*"
                            placeholder="Days"
                            size="large"
                          />
                        </Col>
                        <Col span={12}>
                          <Input
                            name="maximumLeaveAccumulatedFromLastYear"
                            label="Maximum Leave Accumulated From Last Year"
                            placeholder="Days"
                            size="large"
                          />
                        </Col>
                        <Col span={12}>
                          <Select
                            name="expiringMonth"
                            label="Expiring Month"
                            placeholder="Please Select"
                            size="large"
                            options={[
                              { label: "January", value: "january" },
                              { label: "February", value: "february" },
                              { label: "March", value: "march" },
                              { label: "April", value: "april" },
                              { label: "May", value: "may" },
                              { label: "June", value: "june" },
                              { label: "July", value: "july" },
                              { label: "August", value: "august" },
                              { label: "September", value: "september" },
                              { label: "October", value: "october" },
                              { label: "November", value: "november" },
                              { label: "December", value: "december" },
                            ]}
                          />
                        </Col>
                        <Col span={12}></Col>
                        <Col span={12}>
                          <Select
                            name="gender"
                            label="Gender  *"
                            placeholder="Gender *"
                            size="large"
                            options={[
                              { label: "All Gender", value: "all_Gender" },
                              { label: "Male", value: "male" },
                              { label: "Female", value: "female" },
                            ]}
                          />
                        </Col>

                        <Col span={12}>
                          <Input
                            name="leaveCalculation"
                            label="Leave Calculation *"
                            placeholder=""
                            size="large"
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row justify="end" style={{ paddingTop: "24px" }}>
                    <Space size={24}>
                      <Button
                        type="default"
                        onClick={() => {
                          goToCancle();
                          setMenu("leave");
                        }}
                      >
                        CANCEL
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        onClick={onSubmitCreate}
                      >
                        CREATE
                      </Button>
                    </Space>
                  </Row>
                </div>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </MainLayout>
  );
};

export default AttendanceCreate;
